// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import { TokenManagerConfig } from '@protolabs/enterprise-token-manager';

const config: TokenManagerConfig = {
	acrValues: '',
	authority: window.authorityUri,
	clientId: window.clientId,
	redirectUri: window.defaultReturnUri,
	postLogoutRedirectUri: window.postLogoutUri,
	monitorOnRedirectUri: false,
	filterProtocolClaims: false,
	useUnsecureWebSockets: import.meta.env.DEV,
};

if (import.meta.env.DEV) {
	// Increase renew window to 5 minutes before expiration.
	config.refreshAccessTokenExpireOffset = 300;

	// config.logLevel = LogLevel.DEBUG;
	// config.maxRefreshTokenExpireMinutes = 1;
}

export default config;
